export default __webpack_public_path__ + "static/media/company.39da9513.svg";